import type { Passenger } from '@optionway/models';

export const isPassengerComplete = (
  passenger: Passenger,
  documentRequired: boolean,
  referenceDate: string | undefined,
  now: string,
): boolean => {
  if (Object.values(validatePassengerFields(passenger)).some(Boolean)) {
    return false;
  }
  if (validateBirthdate(passenger, referenceDate, now)) {
    return false;
  }
  if (!documentRequired) {
    return true;
  }
  const document = passenger.documents?.[0];
  return !!document && !!parsePassportDocument(document, now).document;
};
